import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  sendPropertyData: makeAxiosRequest('/admin/properties', { method: 'post' }),
  sendPropertyDocuments: makeAxiosRequest('/admin/properties/{`id`}/documents', { method: 'post' }),
  editProperty: makeAxiosRequest('/admin/properties/{`id`}', { method: 'put' }),
};
